module.exports = __webpack_public_path__ + "img/About-us.a2c1e8b0.jpg";